// extracted by mini-css-extract-plugin
module.exports = {"blockForm":"company-info-form_blockForm__2zG-n","blockFormItem":"company-info-form_blockFormItem__1OkbQ","blockAction":"company-info-form_blockAction__ChRmO"};